var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temCodigo
    ? _c(
        "div",
        _vm._b(
          { staticClass: "codigo-executado ia-block-card" },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            "button",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita ia-block-card__cabecalho--clicavel",
              attrs: {
                type: "button",
                "aria-expanded": String(_vm.aberto),
                "aria-label": _vm.CODIGO_DO_TURNO.ARIA_LISTA,
                "data-test": "codigo-executado-cabecalho"
              },
              on: { click: _vm.alternar }
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: { name: "monitor", size: 14, color: "var(--primary)" }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.CODIGO_DO_TURNO.TITULO))
              ]),
              _c("span", { staticClass: "ia-block-card__meta" }, [
                _vm._v(_vm._s(_vm.resumo))
              ]),
              _c("icon-svg", {
                staticClass: "ia-block-seta",
                class: _vm.classeSeta,
                attrs: {
                  name: "arrow-down-new-ux",
                  size: 14,
                  color: "var(--neutral-700)"
                }
              })
            ],
            1
          ),
          _vm._l(_vm.itens, function(item) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.aberto,
                    expression: "aberto"
                  }
                ],
                key: item.chave,
                staticClass: "codigo-executado__item",
                attrs: { "data-test": "codigo-executado-item" }
              },
              [
                _c(
                  "div",
                  { staticClass: "codigo-executado__topo" },
                  [
                    _c("BaseStatus", {
                      attrs: {
                        soft: "",
                        "preserve-case": "",
                        color: "secondary",
                        content: item.linguagem
                      }
                    }),
                    item.onde
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "codigo-executado__onde ia-texto-auxiliar"
                          },
                          [_vm._v(_vm._s(item.onde))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                item.frase
                  ? _c(
                      "p",
                      {
                        staticClass:
                          "codigo-executado__frase ia-texto-auxiliar",
                        attrs: {
                          role: "alert",
                          "data-test": "codigo-executado-frase"
                        }
                      },
                      [_vm._v(" " + _vm._s(item.frase) + " ")]
                    )
                  : _vm._e(),
                item.trecho
                  ? _c(
                      "pre",
                      { staticClass: "codigo-executado__trecho ia-texto-mono" },
                      [_vm._v(_vm._s(item.trecho))]
                    )
                  : _vm._e(),
                item.podeAlternar
                  ? _c(
                      "button",
                      {
                        staticClass: "codigo-executado__alternar ia-texto-selo",
                        attrs: {
                          type: "button",
                          "data-test": "codigo-executado-alternar"
                        },
                        on: {
                          click: function($event) {
                            return _vm.alternarTrecho(item.indice)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(item.rotuloAlternar) + " ")]
                    )
                  : _vm._e(),
                item.saida
                  ? _c("div", { staticClass: "codigo-executado__saida" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "codigo-executado__saida-rotulo ia-texto-selo"
                        },
                        [_vm._v(_vm._s(_vm.CODIGO_DO_TURNO.SAIDA))]
                      ),
                      _c(
                        "pre",
                        {
                          staticClass: "codigo-executado__trecho ia-texto-mono"
                        },
                        [_vm._v(_vm._s(item.saida))]
                      )
                    ])
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }